export class PreviewImageField {

  removeImage: boolean = false;
  constructor(element: HTMLElement, t?: any) {
    const imageInput: HTMLInputElement = element.querySelector("input.custom-file-input");
    const fieldName = imageInput.getAttribute('name');
    const fieldId = imageInput.getAttribute('id');
    let fieldValue = imageInput.dataset.imageUrl || "";
    if (!fieldValue.startsWith('http')) fieldValue = "";
    document.querySelector(`label[for=${imageInput.id}]`).classList.add("mb-2");

    const removeImageField = this.createRemoveImageHiddenField(fieldName);
    const removeButton = this.createRemoveButton(t);
    const undoButton = this.createUndoButton(t);
    element.parentElement.prepend(removeImageField);
    imageInput.parentElement.append(undoButton);
    imageInput.parentElement.append(removeButton);

    let preview: HTMLImageElement = element.querySelector(`#${fieldId}Preview`);
    if (preview === null) {
      preview = this.createImagePreviewElement(fieldValue, t);
      const container = this.createImagePreviewContainer();
      container.appendChild(preview);
      preview.onload = () => container.classList.add("border");
      element.parentElement.insertBefore(container, element);
    }
    if (fieldValue !== "") {
      preview.classList.remove("visually-hidden");
    }
    removeButton.classList.toggle('disabled', fieldValue === "");

    imageInput.onchange = function (_event) {
      undoButton.click()
      const file = imageInput.files[0];
      preview.src = URL.createObjectURL(file);
      preview.classList.remove("visually-hidden");
      fieldValue = preview.src
      removeButton.classList.remove('disabled');
    }
    removeButton.onclick = function () {
      preview.style.opacity = "0.5";
      removeImageField.value = '1';
      undoButton.classList.toggle('visually-hidden', false);
      removeButton.classList.toggle('visually-hidden', true);
    };
    undoButton.onclick = function () {
      preview.style.opacity = "1.0";
      removeImageField.value = '';
      undoButton.classList.toggle('visually-hidden', true);
      removeButton.classList.toggle('visually-hidden', false);
    };
  }

  createRemoveImageHiddenField(inputName: string) {
    const element = document.createElement("input");
    element.type = "hidden";
    element.name = inputName.replace(/\[([^[]+)]$/, "[remove_$1]");
    return element;
  }

  createUndoButton(t?: any) {
    const element = document.createElement("button");
    element.type = "button";
    element.className = "btn btn-outline-primary rounded-end";
    element.classList.add("visually-hidden");
    element.innerHTML = "<span class=\"fas fa-undo\"></span>";
    if (!!t) element.ariaLabel = t("js.actions.undo");
    return element;
  }

  createRemoveButton(t?: any) {
    const element = document.createElement("button");
    element.type = "button";
    element.className = "btn btn-danger disabled";
    element.innerHTML = "<span class=\"fas fa-trash\"></span>";
    if (!!t) element.ariaLabel = t("js.actions.delete");
    return element;
  }

  createImagePreviewContainer(): HTMLDivElement {
    const container = document.createElement("div");
    container.className = "rounded w-100 text-center mb-1 bg-light";

    return container
  }

  createImagePreviewElement(imageUrl: string, t?: any) {
    const element = document.createElement("img");
    element.src = imageUrl;
    element.className = `img-fluid mx-auto d-block ${!!element.src ? "visually-hidden" : ""}`;
    element.style.maxHeight = "10rem";
    if (!!t) element.alt = t("js.components.AVFileInput.alt_preview");
    return element;
  }
}
